import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import moment from "moment";
import Recaptcha from "../../modules/Recaptcha/Recaptchav2";

// import {
//   GoogleReCaptchaProvider,
//   useGoogleReCaptcha,
// } from "react-google-recaptcha-v3";

const SignIn = ({ dispatch_post_authin }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  const [recaptcha, set_recaptcha] = useState("");

  // const { executeRecaptcha } = useGoogleReCaptcha();
  // const recaptcha =  executeRecaptcha("login");

  useEffect(() => {}, []);

  const [mail_address, set_mail_address] = useState("");
  // const [phone_number, set_phone_number] = useState("");
  const [password, set_password] = useState("");

  return (
    <>
      <div className="d-flex flex-column justify-content-between bg-light vh-100">
        <header className="py-3 mb-auto bg-brand">
          <div className="container d-flex justify-content-between align-items-center">
            <a
              className="text-white"
              href="javascript:history.back();"
              onClick={(e) => {
                e.preventDefault();
                history.goBack();
                window.scroll(0, 0);
              }}
            >
              <i className="fas fa-angle-left fa-fw" />
              {t("戻る")}
            </a>
            <a
              href="index.html"
              onClick={(e) => {
                e.preventDefault();
                history.push({
                  pathname: `/top`,
                });
                window.scroll(0, 0);
              }}
            >
              <img src="images/brand-white.svg" height={28} alt="SC WORLD EXCHANGE" />
            </a>
          </div>
        </header>
        <main role="main" className="main">
          <div className="container">
            <section className="login-section mx-auto mb-4">
              <div className="card">
                <div className="card-body">
                  <form action="account/index.html" method="post">
                    <h1 className="h4 text-center font-weight-bold">
                      {t("ログイン")}
                    </h1>
                    <span className="d-block text-center mb-4">
                      {t("SC WORLD EXCHANGE アカウント")}
                    </span>
                    <div className="form-group">
                      <label htmlFor="ml">{t("メールアドレス")}</label>
                      <input
                        type="email"
                        id="ml"
                        className="form-control"
                        placeholder={t("メールアドレス")}
                        required
                        // autoFocus
                        value={mail_address}
                        onChange={(e) => {
                          set_mail_address(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="pw">{t("パスワード")}</label>
                      <input
                        type="password"
                        id="pw"
                        className="form-control"
                        placeholder={t("パスワードを入力してください")}
                        required
                        value={password}
                        onChange={(e) => {
                          set_password(e.target.value);
                        }}
                      />
                    </div>
                    <a
                      className="d-block mt-2 mb-4"
                      href="recovery-pw.html"
                      onClick={(e) => {
                        e.preventDefault();
                        history.push({
                          pathname: `/recovery-pw`,
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      <small>{t("パスワードを忘れましたか？")}</small>
                    </a>
                    <div className="form-group text-center">
                      {/* {t("Google reCAPTCHA")} */}
                      <Recaptcha set_recaptcha={set_recaptcha} action="login" />
                    </div>
                    <div className="form-group mb-0">
                      <button
                        type="button"
                        className="btn btn-gradient-primary btn-block"
                        onClick={async (e) => {
                          e.preventDefault();

                          dispatch_post_authin(
                            {
                              recaptcha: recaptcha,
                              mail_address,
                              password,
                              type: 2,
                            },
                            (data) => {
                              if (data.hash) {
                                history.push({
                                  pathname: `/signincode`,
                                });
                                window.scroll(0, 0);
                              } else {
                                history.push({
                                  pathname: `/exch-market`,
                                  nonce: moment().unix(),
                                });
                        window.jQuery(".navbar-toggler").click();
                                window.scroll(0, 0);
                                // window.location.reload();
                                // window.location.href = "/dashboard"
                              }
                            }
                          );
                        }}
                      >
                        {t("ログイン")}
                      </button>
                      <hr />
                      <a
                        className="btn btn-outline-secondary btn-block"
                        href="signup.html"
                        onClick={(e) => {
                          e.preventDefault();
                          history.push({
                            pathname: `/signup`,
                          });
                          window.scroll(0, 0);
                        }}
                      >
                        {t("新規登録")}
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          </div>
        </main>
        <footer className="mt-auto" />
      </div>
    </>
  );
};

export default SignIn;
